import logo from '/Avaros_favicon.svg';
import UserDropdown from './UserDropdown.tsx';

export default function TopBar() {
  return (
    <header className="gradient-header relative z-[1000] shrink-0 rounded-xl text-white">
      <div className="flex items-center justify-between gap-4 px-4 py-2.5">
        <div className="flex min-w-0 items-center gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-primary/25 bg-primary/10">
            <img src={logo} className="h-[18px] w-[18px]" alt="Zubee Factory logo" />
          </div>
          <div className="min-w-0">
            <p className="truncate text-[9px] font-semibold uppercase tracking-[0.18em] text-white/35">Zubee Factory</p>
            <h1 className="truncate text-sm font-semibold tracking-tight text-white/85">Orthodontist Workspace</h1>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2 border-l border-white/6 pl-4">
          <UserDropdown />
        </div>
      </div>
      <div className="h-px bg-gradient-to-r from-transparent via-primary/25 to-transparent" />
    </header>
  );
}
